import { render } from "./homeFrame.vue?vue&type=template&id=0b1aa413&scoped=true"
import script from "./homeFrame.vue?vue&type=script&lang=js"
export * from "./homeFrame.vue?vue&type=script&lang=js"

import "./homeFrame.vue?vue&type=style&index=0&id=0b1aa413&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1aa413"]])

export default __exports__